export const ConnectionLostNotification = () => {
    return (
        <div className="connection-lost-notification">
            <p>Connection lost</p>
        </div>
    )
}